import { serverApiSlice } from '@store/api/rootEndpoints';
import { store } from '@store/store';

/**
 * Fetches the server configuration before the app renders. A failure here means the
 * backend is unreachable, which is worth showing as its own screen rather than letting
 * every page fail individually.
 */
export const initializeApp = async () => {
  try {
    return await store.dispatch(
      serverApiSlice.endpoints.getConfig.initiate(undefined, {
        forceRefetch: true,
        subscribe: false,
      })).unwrap();

  } catch (error) {
    console.error('main.initializeApp:', error);
    throw error;
  }
};
